import axios from "axios";
import { configUrl } from "config.js";

const getTesScheduletData = async (testId) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/Tests/getProviderTestScheduling/${testId}`
    );
    let data = response.data;
    console.log(data, 'data in service')

    return data;
};
export default {
    getTesScheduletData: getTesScheduletData,
}